import { useState, type FormEvent } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api, ApiRequestError } from "../../lib/api";
import { authClient } from "../../lib/auth-client";

export function AcceptInvitationPage() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const navigate = useNavigate();
  const [displayName, setDisplayName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    if (!token) {
      setError("Der Einladungslink ist unvollständig.");
      return;
    }
    setSubmitting(true);
    try {
      const result = await api.post<{ userId: string; email: string }>("/api/v1/invitations/accept", {
        token,
        password,
        displayName
      });
      // The account now exists; sign in with the just-set credentials since
      // acceptance itself doesn't establish a session (it runs server-side only).
      await authClient.signIn.email({ email: result.email, password });
      void navigate("/", { replace: true });
    } catch (err) {
      setError(err instanceof ApiRequestError ? err.message : "Einladung konnte nicht angenommen werden.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="pw-centered-page">
      <div className="pw-centered-page__panel pw-card">
        <h1 style={{ margin: "0 0 0.3rem", fontSize: "1.4rem", fontWeight: 600 }}>Einladung annehmen</h1>
        <p style={{ margin: "0 0 1.2rem", fontSize: "0.85rem", color: "var(--pw-color-text-muted)" }}>
          Lege deinen Namen und ein Passwort fest, um dein Konto zu aktivieren.
        </p>
        {error && (
          <div className="pw-alert pw-alert--error" role="alert">
            {error}
          </div>
        )}
        <form onSubmit={(e) => void onSubmit(e)} noValidate>
          <div className="pw-field">
            <label htmlFor="displayName">Anzeigename</label>
            <input id="displayName" required value={displayName} onChange={(e) => setDisplayName(e.target.value)} />
          </div>
          <div className="pw-field">
            <label htmlFor="password">Passwort (mind. 12 Zeichen)</label>
            <input
              id="password"
              type="password"
              autoComplete="new-password"
              minLength={12}
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button type="submit" className="pw-button pw-button--primary" disabled={submitting} style={{ width: "100%" }}>
            {submitting ? "Wird eingerichtet …" : "Konto aktivieren"}
          </button>
        </form>
      </div>
    </div>
  );
}
